(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'fixers-s2-s2-automate-s2-automate-dsl'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'fixers-s2-s2-automate-s2-automate-dsl'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'fixers-s2-s2-automate-s2-automate-dsl'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'fixers-s2-s2-automate-s2-automate-dsl'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'fixers-s2-s2-automate-s2-automate-dsl'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'fixers-s2-s2-automate-s2-automate-dsl'.");
    }
    root['fixers-s2-s2-automate-s2-automate-dsl'] = factory(typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined' ? {} : this['fixers-s2-s2-automate-s2-automate-dsl'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-core'], this['fixers-f2-f2-dsl-f2-dsl-cqrs']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_komune_f2_f2_dsl_cqrs) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.fa;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var getKClass = kotlin_kotlin.$_$.f;
  var ReferenceArraySerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a2;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var VOID = kotlin_kotlin.$_$.g;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var objectCreate = kotlin_kotlin.$_$.da;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var copyToArray = kotlin_kotlin.$_$.z5;
  var classMeta = kotlin_kotlin.$_$.z8;
  var defineProp = kotlin_kotlin.$_$.b9;
  var Command = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.c;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var emptyList = kotlin_kotlin.$_$.b6;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ke;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Automate, 'Automate', interfaceMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(S2Automate, 'S2Automate', classMeta, VOID, [Automate], VOID, VOID, {0: $serializer_getInstance});
  setMetadataFor(S2InitCommand, 'S2InitCommand', interfaceMeta, VOID, [Command]);
  setMetadataFor(WithId, 'WithId', interfaceMeta);
  setMetadataFor(S2Command, 'S2Command', interfaceMeta, VOID, [Command, WithId]);
  setMetadataFor(S2Error, 'S2Error', interfaceMeta);
  setMetadataFor(S2ErrorBase, 'S2ErrorBase', classMeta, VOID, [S2Error]);
  setMetadataFor(S2Event, 'S2Event', interfaceMeta, VOID, [Event, WithId]);
  setMetadataFor(S2EventSuccess, 'S2EventSuccess', classMeta, VOID, [Event]);
  setMetadataFor(S2EventError, 'S2EventError', classMeta, VOID, [Event]);
  setMetadataFor(S2Role, 'S2Role', interfaceMeta);
  setMetadataFor(S2State, 'S2State', interfaceMeta);
  setMetadataFor(S2SubMachine, 'S2SubMachine', classMeta);
  setMetadataFor(S2InitTransition, 'S2InitTransition', classMeta);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(S2Transition, 'S2Transition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(S2TransitionValue, 'S2TransitionValue', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(S2RoleValue, 'S2RoleValue', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(S2StateValue, 'S2StateValue', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(S2AutomateBuilder, 'S2AutomateBuilder', classMeta, VOID, VOID, S2AutomateBuilder);
  setMetadataFor(S2SourcingAutomateBuilder, 'S2SourcingAutomateBuilder', classMeta, VOID, VOID, S2SourcingAutomateBuilder);
  setMetadataFor(S2TransitionBuilder, 'S2TransitionBuilder', classMeta, VOID, VOID, S2TransitionBuilder);
  setMetadataFor(S2SelfTransitionBuilder, 'S2SelfTransitionBuilder', classMeta, VOID, VOID, S2SelfTransitionBuilder);
  setMetadataFor(WithS2Id, 'WithS2Id', interfaceMeta);
  setMetadataFor(WithS2State, 'WithS2State', interfaceMeta);
  setMetadataFor(WithS2IdAndStatus, 'WithS2IdAndStatus', interfaceMeta, VOID, [WithS2Id, WithS2State]);
  //endregion
  function Automate() {
  }
  function isInstance(_this__u8e3s4, $this, msg) {
    var msgAction = toValue(getKClassFromExpression(msg));
    return msgAction.name === _this__u8e3s4.name;
  }
  function isSame(_this__u8e3s4, $this, to) {
    return (_this__u8e3s4 == null ? null : _this__u8e3s4.position) === to.position;
  }
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s25_1 = [null, null, new ReferenceArraySerializer(getKClass(S2Transition), $serializer_getInstance_0())];
  }
  protoOf(Companion).x14 = function () {
    return $serializer_getInstance();
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('s2.dsl.automate.S2Automate', this, 3);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('version', false);
    tmp0_serialDesc.ht('transitions', false);
    this.t25_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.t25_1;
  };
  protoOf($serializer).wt = function () {
    var tmp0_cached = Companion_getInstance().s25_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[2]];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.t25_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    var tmp8_cached = Companion_getInstance().s25_1;
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.gm(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.gm(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return S2Automate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer).u25 = function (encoder, value) {
    var tmp0_desc = this.t25_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance().s25_1;
    tmp1_output.jn(tmp0_desc, 0, value.name);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.version);
    tmp1_output.ln(tmp0_desc, 2, tmp2_cached[2], value.transitions);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.u25(encoder, value instanceof S2Automate ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function S2Automate_init_$Init$(seen1, name, version, transitions, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance().t25_1);
    }
    $this.name = name;
    $this.version = version;
    $this.transitions = transitions;
    return $this;
  }
  function S2Automate_init_$Create$(seen1, name, version, transitions, serializationConstructorMarker) {
    return S2Automate_init_$Init$(seen1, name, version, transitions, serializationConstructorMarker, objectCreate(protoOf(S2Automate)));
  }
  function S2Automate(name, version, transitions) {
    Companion_getInstance();
    this.name = name;
    this.version = version;
    this.transitions = transitions;
  }
  protoOf(S2Automate).h9 = function () {
    return this.name;
  };
  protoOf(S2Automate).v25 = function () {
    return this.version;
  };
  protoOf(S2Automate).g22 = function () {
    return this.transitions;
  };
  protoOf(S2Automate).getAvailableTransitions = function (state) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.transitions;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 's2.dsl.automate.S2Automate.getAvailableTransitions.<anonymous>' call
      if (isSame(element.from, this, state)) {
        destination.r(element);
      }
    }
    return copyToArray(destination);
  };
  protoOf(S2Automate).isAvailableTransition = function (currentState, msg) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = this.getAvailableTransitions(currentState);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 's2.dsl.automate.S2Automate.isAvailableTransition.<anonymous>' call
        if (isInstance(element.action, this, msg)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(S2Automate).isAvailableInitTransition = function (command) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = this.transitions;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 's2.dsl.automate.S2Automate.isAvailableInitTransition.<anonymous>' call
        if (element.from == null ? isInstance(element.action, this, command) : false) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(S2Automate).isFinalState = function (state) {
    // Inline function 'kotlin.collections.isEmpty' call
    return this.getAvailableTransitions(state).length === 0;
  };
  protoOf(S2Automate).isSameState = function (from, to) {
    return (from == null ? null : from.position) === to.position;
  };
  function S2InitCommand() {
  }
  function S2Command() {
  }
  function S2Error() {
  }
  function S2ErrorBase(type, description, date, payload, cause) {
    cause = cause === VOID ? null : cause;
    this.z25_1 = type;
    this.a26_1 = description;
    this.b26_1 = date;
    this.c26_1 = payload;
    this.d26_1 = cause;
  }
  protoOf(S2ErrorBase).j21 = function () {
    return this.z25_1;
  };
  protoOf(S2ErrorBase).w25 = function () {
    return this.a26_1;
  };
  protoOf(S2ErrorBase).x25 = function () {
    return this.b26_1;
  };
  protoOf(S2ErrorBase).y25 = function () {
    return this.c26_1;
  };
  protoOf(S2ErrorBase).v5 = function () {
    return this.d26_1;
  };
  protoOf(S2ErrorBase).toString = function () {
    return "S2ErrorBase(type='" + this.z25_1 + "', description='" + this.a26_1 + "', date='" + this.b26_1 + "', payload=" + this.c26_1 + ')';
  };
  function S2Event() {
  }
  function S2EventSuccess(id, type, from, to) {
    this.id = id;
    this.type = type;
    this.from = from;
    this.to = to;
  }
  protoOf(S2EventSuccess).k1y = function () {
    return this.id;
  };
  protoOf(S2EventSuccess).j21 = function () {
    return this.type;
  };
  protoOf(S2EventSuccess).b24 = function () {
    return this.from;
  };
  protoOf(S2EventSuccess).c24 = function () {
    return this.to;
  };
  function S2EventError(id, type, from, to, error) {
    this.id = id;
    this.type = type;
    this.from = from;
    this.to = to;
    this.error = error;
  }
  protoOf(S2EventError).k1y = function () {
    return this.id;
  };
  protoOf(S2EventError).j21 = function () {
    return this.type;
  };
  protoOf(S2EventError).b24 = function () {
    return this.from;
  };
  protoOf(S2EventError).c24 = function () {
    return this.to;
  };
  protoOf(S2EventError).w1y = function () {
    return this.error;
  };
  function S2Role() {
  }
  function S2State() {
  }
  function S2SubMachine(automate, startsOn, endsOn, autostart, blocking, singleton) {
    startsOn = startsOn === VOID ? emptyList() : startsOn;
    endsOn = endsOn === VOID ? emptyList() : endsOn;
    autostart = autostart === VOID ? false : autostart;
    blocking = blocking === VOID ? false : blocking;
    singleton = singleton === VOID ? false : singleton;
    this.e26_1 = automate;
    this.f26_1 = startsOn;
    this.g26_1 = endsOn;
    this.h26_1 = autostart;
    this.i26_1 = blocking;
    this.j26_1 = singleton;
  }
  protoOf(S2SubMachine).k26 = function () {
    return this.e26_1;
  };
  protoOf(S2SubMachine).l26 = function () {
    return this.f26_1;
  };
  protoOf(S2SubMachine).m26 = function () {
    return this.g26_1;
  };
  protoOf(S2SubMachine).n26 = function () {
    return this.h26_1;
  };
  protoOf(S2SubMachine).o26 = function () {
    return this.i26_1;
  };
  protoOf(S2SubMachine).p26 = function () {
    return this.j26_1;
  };
  function S2InitTransition(to, role, action) {
    this.q26_1 = to;
    this.r26_1 = role;
    this.s26_1 = action;
  }
  protoOf(S2InitTransition).c24 = function () {
    return this.q26_1;
  };
  protoOf(S2InitTransition).d24 = function () {
    return this.r26_1;
  };
  protoOf(S2InitTransition).e24 = function () {
    return this.s26_1;
  };
  function Companion_0() {
  }
  protoOf(Companion_0).x14 = function () {
    return $serializer_getInstance_0();
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('s2.dsl.automate.S2Transition', this, 5);
    tmp0_serialDesc.ht('from', false);
    tmp0_serialDesc.ht('to', false);
    tmp0_serialDesc.ht('role', false);
    tmp0_serialDesc.ht('action', false);
    tmp0_serialDesc.ht('result', false);
    this.t26_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.t26_1;
  };
  protoOf($serializer_0).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_3()), $serializer_getInstance_3(), $serializer_getInstance_2(), $serializer_getInstance_1(), get_nullable($serializer_getInstance_1())];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.t26_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.ul(tmp0_desc);
    if (tmp9_input.km()) {
      tmp4_local0 = tmp9_input.im(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.gm(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.gm(tmp0_desc, 2, $serializer_getInstance_2(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.gm(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.im(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.im(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.gm(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.gm(tmp0_desc, 2, $serializer_getInstance_2(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.gm(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.im(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.vl(tmp0_desc);
    return S2Transition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_0).u26 = function (encoder, value) {
    var tmp0_desc = this.t26_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.nn(tmp0_desc, 0, $serializer_getInstance_3(), value.from);
    tmp1_output.ln(tmp0_desc, 1, $serializer_getInstance_3(), value.to);
    tmp1_output.ln(tmp0_desc, 2, $serializer_getInstance_2(), value.role);
    tmp1_output.ln(tmp0_desc, 3, $serializer_getInstance_1(), value.action);
    tmp1_output.nn(tmp0_desc, 4, $serializer_getInstance_1(), value.result);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.u26(encoder, value instanceof S2Transition ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function S2Transition_init_$Init$(seen1, from, to, role, action, result, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen1))) {
      throwMissingFieldException(seen1, 31, $serializer_getInstance_0().t26_1);
    }
    $this.v26_1 = from;
    $this.w26_1 = to;
    $this.x26_1 = role;
    $this.y26_1 = action;
    $this.z26_1 = result;
    return $this;
  }
  function S2Transition_init_$Create$(seen1, from, to, role, action, result, serializationConstructorMarker) {
    return S2Transition_init_$Init$(seen1, from, to, role, action, result, serializationConstructorMarker, objectCreate(protoOf(S2Transition)));
  }
  function S2Transition(from, to, role, action, result) {
    this.v26_1 = from;
    this.w26_1 = to;
    this.x26_1 = role;
    this.y26_1 = action;
    this.z26_1 = result;
  }
  protoOf(S2Transition).b24 = function () {
    return this.v26_1;
  };
  protoOf(S2Transition).c24 = function () {
    return this.w26_1;
  };
  protoOf(S2Transition).d24 = function () {
    return this.x26_1;
  };
  protoOf(S2Transition).e24 = function () {
    return this.y26_1;
  };
  protoOf(S2Transition).ab = function () {
    return this.z26_1;
  };
  function Companion_1() {
  }
  protoOf(Companion_1).x14 = function () {
    return $serializer_getInstance_1();
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('s2.dsl.automate.S2TransitionValue', this, 1);
    tmp0_serialDesc.ht('name', false);
    this.a27_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.a27_1;
  };
  protoOf($serializer_1).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.a27_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return S2TransitionValue_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_1).b27 = function (encoder, value) {
    var tmp0_desc = this.a27_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.name);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.b27(encoder, value instanceof S2TransitionValue ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function S2TransitionValue_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_1().a27_1);
    }
    $this.name = name;
    return $this;
  }
  function S2TransitionValue_init_$Create$(seen1, name, serializationConstructorMarker) {
    return S2TransitionValue_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(S2TransitionValue)));
  }
  function S2TransitionValue(name) {
    this.name = name;
  }
  protoOf(S2TransitionValue).h9 = function () {
    return this.name;
  };
  function Companion_2() {
  }
  protoOf(Companion_2).x14 = function () {
    return $serializer_getInstance_2();
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('s2.dsl.automate.S2RoleValue', this, 1);
    tmp0_serialDesc.ht('name', false);
    this.c27_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.c27_1;
  };
  protoOf($serializer_2).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.c27_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return S2RoleValue_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_2).d27 = function (encoder, value) {
    var tmp0_desc = this.c27_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.name);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.d27(encoder, value instanceof S2RoleValue ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function S2RoleValue_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_2().c27_1);
    }
    $this.name = name;
    return $this;
  }
  function S2RoleValue_init_$Create$(seen1, name, serializationConstructorMarker) {
    return S2RoleValue_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(S2RoleValue)));
  }
  function S2RoleValue(name) {
    this.name = name;
  }
  protoOf(S2RoleValue).h9 = function () {
    return this.name;
  };
  function Companion_3() {
  }
  protoOf(Companion_3).x14 = function () {
    return $serializer_getInstance_3();
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('s2.dsl.automate.S2StateValue', this, 2);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('position', false);
    this.e27_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.e27_1;
  };
  protoOf($serializer_3).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.e27_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zl(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zl(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return S2StateValue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).f27 = function (encoder, value) {
    var tmp0_desc = this.e27_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.name);
    tmp1_output.en(tmp0_desc, 1, value.position);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.f27(encoder, value instanceof S2StateValue ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function S2StateValue_init_$Init$(seen1, name, position, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_3().e27_1);
    }
    $this.name = name;
    $this.position = position;
    return $this;
  }
  function S2StateValue_init_$Create$(seen1, name, position, serializationConstructorMarker) {
    return S2StateValue_init_$Init$(seen1, name, position, serializationConstructorMarker, objectCreate(protoOf(S2StateValue)));
  }
  function S2StateValue(name, position) {
    this.name = name;
    this.position = position;
  }
  protoOf(S2StateValue).h9 = function () {
    return this.name;
  };
  protoOf(S2StateValue).jr = function () {
    return this.position;
  };
  function toValue(_this__u8e3s4) {
    return new S2TransitionValue(ensureNotNull(_this__u8e3s4.z5()));
  }
  function toValue_0(_this__u8e3s4) {
    return new S2StateValue(ensureNotNull(getKClassFromExpression(_this__u8e3s4).z5()), _this__u8e3s4.position);
  }
  function toValue_1(_this__u8e3s4) {
    return new S2RoleValue(ensureNotNull(getKClassFromExpression(_this__u8e3s4).z5()));
  }
  function WithId() {
  }
  function s2(exec) {
    var builder = new S2AutomateBuilder();
    exec(builder);
    var tmp = builder.h9();
    var tmp_0 = builder.h27_1;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.i27_1;
    var tmp$ret$0 = copyToArray(this_0);
    return new S2Automate(tmp, tmp_0, tmp$ret$0);
  }
  function S2AutomateBuilder() {
    this.h27_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.i27_1 = ArrayList_init_$Create$();
  }
  protoOf(S2AutomateBuilder).h9 = function () {
    var tmp = this.g27_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('name');
    }
  };
  function s2Sourcing(exec) {
    var builder = new S2SourcingAutomateBuilder();
    exec(builder);
    var tmp = builder.h9();
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.l27_1;
    var tmp$ret$0 = copyToArray(this_0);
    return new S2Automate(tmp, builder.k27_1, tmp$ret$0);
  }
  function S2SourcingAutomateBuilder() {
    this.k27_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.l27_1 = ArrayList_init_$Create$();
  }
  protoOf(S2SourcingAutomateBuilder).h9 = function () {
    var tmp = this.j27_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('name');
    }
  };
  function S2TransitionBuilder() {
    this.m27_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.n27_1 = ArrayList_init_$Create$();
    this.q27_1 = null;
  }
  protoOf(S2TransitionBuilder).c24 = function () {
    var tmp = this.o27_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('to');
    }
  };
  protoOf(S2TransitionBuilder).d24 = function () {
    var tmp = this.p27_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('role');
    }
  };
  function S2SelfTransitionBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.r27_1 = ArrayList_init_$Create$();
    this.t27_1 = null;
  }
  protoOf(S2SelfTransitionBuilder).d24 = function () {
    var tmp = this.s27_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('role');
    }
  };
  function isAvailableTransition(_this__u8e3s4, state, type) {
    return !(state == null) ? isAvailableTransition_0(_this__u8e3s4, state.s2State(), type) : false;
  }
  function isAvailableTransition_0(_this__u8e3s4, currentState, type) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = _this__u8e3s4.getAvailableTransitions(currentState);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 's2.dsl.automate.extention.isAvailableTransition.<anonymous>' call
        var tmp;
        var tmp0_safe_receiver = element.result;
        if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name) === type) {
          tmp = true;
        } else {
          tmp = element.action.name === type;
        }
        if (tmp) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function WithS2Id() {
  }
  function WithS2IdAndStatus() {
  }
  function WithS2State() {
  }
  //region block: post-declaration
  protoOf($serializer).xt = typeParametersSerializers;
  defineProp(protoOf(S2ErrorBase), 'type', function () {
    return this.j21();
  });
  defineProp(protoOf(S2ErrorBase), 'description', function () {
    return this.w25();
  });
  defineProp(protoOf(S2ErrorBase), 'date', function () {
    return this.x25();
  });
  defineProp(protoOf(S2ErrorBase), 'payload', function () {
    return this.y25();
  });
  defineProp(protoOf(S2ErrorBase), 'cause', function () {
    return this.v5();
  });
  defineProp(protoOf(S2SubMachine), 'automate', function () {
    return this.k26();
  });
  defineProp(protoOf(S2SubMachine), 'startsOn', function () {
    return this.l26();
  });
  defineProp(protoOf(S2SubMachine), 'endsOn', function () {
    return this.m26();
  });
  defineProp(protoOf(S2SubMachine), 'autostart', function () {
    return this.n26();
  });
  defineProp(protoOf(S2SubMachine), 'blocking', function () {
    return this.o26();
  });
  defineProp(protoOf(S2SubMachine), 'singleton', function () {
    return this.p26();
  });
  defineProp(protoOf(S2InitTransition), 'to', function () {
    return this.c24();
  });
  defineProp(protoOf(S2InitTransition), 'role', function () {
    return this.d24();
  });
  defineProp(protoOf(S2InitTransition), 'action', function () {
    return this.e24();
  });
  protoOf($serializer_0).xt = typeParametersSerializers;
  defineProp(protoOf(S2Transition), 'from', function () {
    return this.b24();
  });
  defineProp(protoOf(S2Transition), 'to', function () {
    return this.c24();
  });
  defineProp(protoOf(S2Transition), 'role', function () {
    return this.d24();
  });
  defineProp(protoOf(S2Transition), 'action', function () {
    return this.e24();
  });
  defineProp(protoOf(S2Transition), 'result', function () {
    return this.ab();
  });
  protoOf($serializer_1).xt = typeParametersSerializers;
  protoOf($serializer_2).xt = typeParametersSerializers;
  protoOf($serializer_3).xt = typeParametersSerializers;
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Companion_instance_3 = new Companion_3();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    $s2$dsl$automate.S2Automate = S2Automate;
    defineProp($s2$dsl$automate.S2Automate, 'Companion', Companion_getInstance);
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    $s2$dsl$automate.S2ErrorBase = S2ErrorBase;
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    $s2$dsl$automate.S2EventSuccess = S2EventSuccess;
    $s2$dsl$automate.S2EventError = S2EventError;
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    $s2$dsl$automate.S2SubMachine = S2SubMachine;
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    $s2$dsl$automate.S2InitTransition = S2InitTransition;
    $s2$dsl$automate.S2Transition = S2Transition;
    defineProp($s2$dsl$automate.S2Transition, 'Companion', Companion_getInstance_0);
    $s2$dsl$automate.S2TransitionValue = S2TransitionValue;
    defineProp($s2$dsl$automate.S2TransitionValue, 'Companion', Companion_getInstance_1);
    $s2$dsl$automate.S2RoleValue = S2RoleValue;
    defineProp($s2$dsl$automate.S2RoleValue, 'Companion', Companion_getInstance_2);
    $s2$dsl$automate.S2StateValue = S2StateValue;
    defineProp($s2$dsl$automate.S2StateValue, 'Companion', Companion_getInstance_3);
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    var $s2$dsl$automate$builder = $s2$dsl$automate.builder || ($s2$dsl$automate.builder = {});
    $s2$dsl$automate$builder.s2 = s2;
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    var $s2$dsl$automate$builder = $s2$dsl$automate.builder || ($s2$dsl$automate.builder = {});
    $s2$dsl$automate$builder.s2Sourcing = s2Sourcing;
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    var $s2$dsl$automate$model = $s2$dsl$automate.model || ($s2$dsl$automate.model = {});
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    var $s2$dsl$automate$model = $s2$dsl$automate.model || ($s2$dsl$automate.model = {});
    var $s2 = _.s2 || (_.s2 = {});
    var $s2$dsl = $s2.dsl || ($s2.dsl = {});
    var $s2$dsl$automate = $s2$dsl.automate || ($s2$dsl.automate = {});
    var $s2$dsl$automate$model = $s2$dsl$automate.model || ($s2$dsl$automate.model = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = S2SelfTransitionBuilder;
  _.$_$.b = S2TransitionBuilder;
  _.$_$.c = s2Sourcing;
  _.$_$.d = isAvailableTransition;
  _.$_$.e = WithS2Id;
  _.$_$.f = WithS2State;
  _.$_$.g = S2Command;
  _.$_$.h = S2InitCommand;
  _.$_$.i = S2Role;
  _.$_$.j = S2State;
  _.$_$.k = S2Transition;
  _.$_$.l = toValue;
  _.$_$.m = toValue_0;
  _.$_$.n = toValue_1;
  //endregion
  return _;
}));

//# sourceMappingURL=fixers-s2-s2-automate-s2-automate-dsl.js.map
